import { inject } from '@angular/core';
import { ActivityEntityName, EntityItemsRequest, manageTenancyRights } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import { EntityDataService } from '@workbuddy/services/entities';
import { ConfirmServicePro } from '@workbuddy/ui/blocks/confirm';
import { Command } from '@workbuddy/ui/model';
import { ToastService } from '@workbuddy/ui/services';
import { EntityBoardStore } from '@workbuddy/ui/v2/blocks/entity.board';

export const PUBLIC_HOLIDAY_CLONE_YEAR_COMMAND = 'cloneYear';

export function publicHolidayCloneYearCommands(): Command[] {

  if (!inject(RightsService).hasRights(...manageTenancyRights)) return [];

  const store = inject(EntityBoardStore);
  const data = inject(EntityDataService);
  const confirm = inject(ConfirmServicePro);
  const toasts = inject(ToastService);
  return [new Command({
    _id: 'public-holiday.clone-year',
    label: 'Clone year',
    iconLeft: 'fa-regular fa-copy',
    action: async () => {
      const year = yearFromItemsRequest(store.$itemsRequest());
      const target = targetCloneYear(year);
      if (!await confirm.confirm('Clone Public Holidays', `Copy tenant extras and shadows from ${year} to ${target}? Generated statewide days are not copied.`, 'info')) return;
      try {
        await data.executeCommand(ActivityEntityName.PublicHoliday, PUBLIC_HOLIDAY_CLONE_YEAR_COMMAND, { year });
        data.invalidateItems(ActivityEntityName.PublicHoliday);
        toasts.success('Public Holidays', `Copied ${year} into ${target}`);
      } catch (error) {
        toasts.error('Public Holidays', error instanceof Error ? error.message : 'Unable to clone year');
      }
    },
  })];
}

function yearFromItemsRequest(request: EntityItemsRequest | null | undefined): number {

  if (request?.segmentId && /^\d{4}$/.test(request.segmentId)) return Number(request.segmentId);
  const value = request?.filters?.find(filter => filter._id === 'year')?.value;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && /^\d{4}$/.test(value)) return Number(value);
  return new Date().getFullYear();
}

function targetCloneYear(sourceYear: number): number {

  const todayYear = new Date().getFullYear();
  return todayYear > sourceYear ? todayYear : todayYear + 1;
}
